/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Qc_Status_ResolvedInputs */



/**
* | output |
* | --- |
* | "Resolved" |
*
* @param {Manual_Qc_Status_ResolvedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_status_resolved = /** @type {((inputs?: Manual_Qc_Status_ResolvedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_Status_ResolvedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Resolue")
	if (locale === "de") return /** @type {LocalizedString} */ ("Gelöst")
	if (locale === "it") return /** @type {LocalizedString} */ ("Risolto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Решено")
	if (locale === "es") return /** @type {LocalizedString} */ ("Resuelto")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("已解决")
	if (locale === "ja") return /** @type {LocalizedString} */ ("解決済み")
	if (locale === "hi") return /** @type {LocalizedString} */ ("हल किया")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Resolvido")
	return /** @type {LocalizedString} */ ("Resolved")
});